import React, {Component} from "react";
import {AutoComplete} from "primereact/autocomplete";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import EnumDirectBillingType from "../direct/EnumDirectBillingType";

export default class CptCodeSelector extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cptList: this.props.cptList || [],
            patientId: this.props.patientId,
            referralType: this.props.referralType
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.patientId !== this.props.patientId) {
            this.setState({patientId: this.props.patientId});
        }

        if (prevProps.referralType !== this.props.referralType && this.props.referralType) {
            this.setState({referralType: this.props.referralType});
        }
    }

    add = (cpt) => {
        const cptList = [...this.state.cptList, cpt]
        this.setState({cptList});

        this.props.onCptSelected(cptList);
    }

    remove = (cpt) => {
        const cptList = this.state.cptList.filter(i => i.id !== cpt.id);
        this.setState({cptList});

        this.props.onCptSelected(cptList);
    }

    cptCodeSearch = (event) => {
        const referralTypeName = EnumDirectBillingType[this.state.referralType].name
        RemotingService.getRemoteCall(`api/cpt/list-external-referral/${this.state.patientId}`, {
            code: event.query,
            speciality: referralTypeName
        }, cptCodes => {
            this.setState({cptCodeSuggestions: cptCodes});
        });
    }

    render() {
        return (
            <div style={{position: 'relative'}}>
                <AutoComplete placeholder="Search..."
                              multiple
                              field="cptCode"
                              value={this.props.cptList}
                              disabled={!this.state.patientId || !this.state.referralType}
                              onChange={event => {
                                  this.setState({cpt: event.value})
                              }}
                              onSelect={event => {
                                  this.add(event.value);
                              }}
                              onUnselect={event => {
                                  this.remove(event.value);
                              }}
                              suggestions={this.state.cptCodeSuggestions}
                              completeMethod={this.cptCodeSearch}
                              itemTemplate={cpt =>
                                  <span>{cpt.cptCode} - {cpt.description}</span>}/>
            </div>
        );
    }
}
